import { render, staticRenderFns } from "./BasicInfoPrimkaAndManual.vue?vue&type=template&id=62569288&scoped=true&"
import script from "./BasicInfoPrimkaAndManual.vue?vue&type=script&lang=js&"
export * from "./BasicInfoPrimkaAndManual.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoPrimkaAndManual.vue?vue&type=style&index=0&id=62569288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62569288",
  null
  
)

export default component.exports